import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';

// 直接导入组件，不使用懒加载
import FirstPage from './pages/first';
import StorySelect from './pages/storySelect';
import StorySetting from './pages/storySetting';
import WorldView from './pages/worldView';
import GenresSelect from './pages/genresSelect';
import StorySummary from './pages/storySummary';

function Layout() {
  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)',
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <Outlet />
    </div>
  );
}

function App() {
  useEffect(() => {
    const setViewportSize = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
      document.documentElement.style.setProperty('--vw', `${window.innerWidth * 0.01}px`);
      document.documentElement.style.overflow = 'hidden';
    };

    setViewportSize();
    window.addEventListener('resize', setViewportSize);

    return () => {
      window.removeEventListener('resize', setViewportSize);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<FirstPage />} />
          <Route path="story-select" element={<StorySelect />} />
          <Route path="story-setting" element={<StorySetting />} />
          <Route path="world-view" element={<WorldView />} />
          <Route path="genres-select" element={<GenresSelect />} />
          <Route path="story-summary" element={<StorySummary />} />
        </Route>
        <Route path="/mobile" element={<Layout />}>
          <Route index element={<FirstPage />} />
          <Route path="story-select" element={<StorySelect />} />
          <Route path="story-setting" element={<StorySetting />} />
          <Route path="world-view" element={<WorldView />} />
          <Route path="genres-select" element={<GenresSelect />} />
          <Route path="story-summary" element={<StorySummary />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;